import { render } from "./table2_zhan.vue?vue&type=template&id=09a48546&scoped=true"
import script from "./table2_zhan.vue?vue&type=script&lang=js"
export * from "./table2_zhan.vue?vue&type=script&lang=js"

import "./table2_zhan.vue?vue&type=style&index=0&id=09a48546&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a48546"]])

export default __exports__